<checkbox 
    *ngFor="let col of allColumns" 
    [single]="true"
    [inputId]="col.name"
    [ngModel]="isChecked(col)" 
    [inline]="true" 
    (onChange)="toggle(col)"
>
    {{ col.name }}
</checkbox>
<div class="mt-3">
    <ngx-datatable
        class="material"
        [rows]="rows"
        [columnMode]="ColumnMode.force"
        [headerHeight]="50"
        [footerHeight]="50"
        rowHeight="auto"
    >
        <ngx-datatable-column *ngFor="let col of columns" [name]="col.name"> </ngx-datatable-column>
    </ngx-datatable>
</div>